import { Box, styled } from '@mui/material';

export const ContentContainer = styled(Box)`
  padding: 0 15px;
`;
